import React, { useState } from "react";
import styles from "./ExperienceCard.module.scss";

const ExperiencePositionCard = ({ position }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={styles.positionBox}>
      <div className={styles.positionHeader}>
        <div className={styles.titleAndCurrent}>
          <h4 className={styles.positionTitle}>{position.title}</h4>
          {position.isCurrent ? <span className={styles.currentBadge}>Current</span> : null}
        </div>
        {/* <div className={styles.dateWithIcon}>
          <CalendarIcon size={16} className={styles.calendarIcon} />
          <span className={styles.dateRange}>
            {position.startDate} - {position.endDate}
          </span>
        </div> */}
      </div>

      <ul className={styles.descriptionList}>
        {(expanded ? position.description : position.description.slice(0, 1)).map(
          (desc, descIndex) => (
            <li key={descIndex}>{desc?.bulletPoint}</li>
          )
        )}
      </ul>
      {position.description.length > 1 && (
        <button type="button" onClick={() => setExpanded(!expanded)} className={styles.toggleBtn}>
          {expanded ? "− Less" : `+ More`}
        </button>
      )}
    </div>
  );
};

export default ExperiencePositionCard;
